import { Component, OnInit, Input, Inject, EventEmitter, Output } from '@angular/core';
import { Location, CurrencyPipe } from '@angular/common';
import { UntypedFormBuilder, UntypedFormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { AlertService, ConstantService } from '@app/_services';
import { ApiResponse } from '@app/_models';
import { Feature } from '@app/_components/property/feature';
import { FeatureService } from '@app/_components/property/feature';
import { RateBucketDetailService } from '../rate-bucket-detail/rate-bucket-detail.service';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { RateBucketDetail } from '../rate-bucket-detail';
import { PercentageValuesPositive, PercentageValuesNegative, PercentageValuesPositiveAndNegative } from '../../../_helpers/constants';
import { RateBucketService } from '../rate-bucket/rate-bucket.service';
import { RateBucket } from '../rate-bucket/rate-bucket';

@Component({
    selector: 'app-rate-bulk-edit',
    templateUrl: './rate-bulk-edit.component.html',
    styleUrls: ['./rate-bulk-edit.component.css'],
    standalone: false
})
export class RateBulkEditComponent implements OnInit
{
  locationIds: any[];

  constructor(
    private currencyPipe: CurrencyPipe,
    private rateBucketDetailService: RateBucketDetailService,
    private rateBucketService: RateBucketService,
    private alertService: AlertService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private formBuilder: UntypedFormBuilder,
    private constantService: ConstantService,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) data)
  {
    this.formTitle = data.title,
      this.rateBucketDetail = data.rateBucketDetail,
      this.formAction = data.formAction
      this.locationIds = this.constantService.locations;
  }


  @Input() shortTermRentalId: number;
  @Input() rateBucketDetail: RateBucketDetail;
  @Output() doBulkEditCB = new EventEmitter<any>();


  // data
  apiResponse: ApiResponse;
  rateBucketDetailId: number;
  rateBucketId: number;
  rateBuckets: any;
  percentageValuesPositive: any = PercentageValuesPositive
  percentageValuesNegative: any = PercentageValuesNegative
  percentageValuesPositiveAndNegative: any = PercentageValuesPositiveAndNegative

  // forms
  form1: UntypedFormGroup;
  formLoading = false;
  formAction: string;
  formLabels = [];
  formReadOnly = false;
  formAlert: string;
  formTitle: string;


  rateBucketTypes = [
    { value: 'RC', name: 'Auto' },
    { value: 'SP', name: 'Manual' }
  ];


  seasonCategories = [
    { value: 1, name: 'Low' },
    { value: 2, name: 'Low-Medium' },
    { value: 3, name: 'Medium' },
    { value: 4, name: 'Medium-High' },
    { value: 5, name: 'High' },
  ];


  discountAlorithms = [
    { value: '1', name: 'Straight Line' },
  ];




  validationMessages = {
    rateBucketDetailId: [],
    rateBucketId: [{ type: 'required', message: 'Required' }],
    locationId: [],
    name: [{ type: 'required', message: 'Required' }],
    rateBucketName: [],
    description: [{ type: 'required', message: 'Required' }],
    publicRateNote: [],
    rateBucketType: [{ type: 'required', message: 'Required' }],
    startDate: [{ type: 'required', message: 'Required' }],
    endDate: [{ type: 'required', message: 'Required' }],
    listPrice: [],
    listPriceAdjustmentPercent: [],
    listPriceAdjustmentAmount: [{ type: 'required', message: 'Required' }],
    minimumPriceSetByManager: [],
    minimumPriceSetByOwner: [],
    seasonCategory: [{ type: 'required', message: 'Required' }],
    seasonOccupancy: [{ type: 'required', message: 'Required' }],
    discountMaxPercent: [],
    discountLookForwardDays: [],
    discountHeadlineSpecialsLookForwardDays: [],
    discountHeadlineSpecialsMinNightsToAnalyze: [],
    discountIntervalDays: [],
    discountCombinationDays: [],
    discountAlorithm: [],
    minStayExpected: [],
    maxStayExpected: [],
    avgStayBySeason: [],
    shortTermGapMultiplier: [],
    shortTermGapPenaltyPercent: [],
    shortTermGapMinNightsReqRev: [],
    longTermGapMultiplier: [],
    longTermGapPenaltyPercent: [],
    longTermGapEmptyMultiplier: [],
    longTermGapEmptyPenaltyPercent: [],
    connectingFrontOrBackMultiplier: [],
    connectingFrontAndBackMultiplier: [],
    lengthOfStayDiscountFactorOffset: [],
  };

  ngOnInit()
  {
    this.formBuild();
    this.loadRateBuckets();

    if (this.rateBucketDetail)
    {
      this.rateBucketDetailId = this.rateBucketDetail.rateBucketDetailId;
      this.form1.patchValue(this.rateBucketDetail);
    }
  }



  onSearchSubmit(searchForm: any)
  {
    this.form1.patchValue({
      reportSearchApi: searchForm
    });
    let a = JSON.stringify(this.getUpdatedInputValues());
    let b = JSON.stringify(this.getUpdatedConditionalValues());

    this.confirmationService.confirm({
      message: 'Are you sure you want to update<br><br><b>' + a + '<br><br>Where<br><br><b>' + JSON.stringify(searchForm) + '</b>?',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      accept: () =>
      {
        this.formSubmit();
        // prevent muliple popups for some reason
        this.confirmationService.close();
      },
      reject: () =>
      {
        this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Bulk Update canceled.', life: 3000 });

        // prevent muliple popups for some reason
        this.confirmationService.close();
      }
    });
  }



  formSubmit()
  {
    try
    {
      console.log('bulk update: ' + JSON.stringify(this.form1.value));
      // stop here if form is invalid
      if (this.form1.invalid)
      {
        console.log('Invalid ');
        return;
      }

      this.formLoading = true;
      this.rateBucketDetailService.bulkUpdate(this.form1.value)
        .subscribe(
          res =>
          {
            console.log('rateBucketDetail-add SUCCESS: ' + JSON.stringify(res));
            this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message, life: 5000 });
            this.doBulkEditCB.emit(res.message);
          },
          err =>
          {
            console.log('rateBucketDetail-add FAIL: ' + JSON.stringify(err));
            this.alertService.error(err);
          },
          () => { this.formLoading = false; });

    } catch (error)
    {
      this.alertService.error(error);
    }
  }


  resetForm()
  {
    this.form1.reset();
    this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Form Reset Successfully ' });
  }


  loadRateBuckets()
  {
    try
    {
      this.rateBucketService.findAll()
        .subscribe(
          res =>
          {
            this.rateBuckets = res.data.rateBuckets;
          },
          err =>
          {
            console.log('loadRateBuckets-add FAIL: ' + JSON.stringify(err));
            this.alertService.error(err);
          },
          () => { this.formLoading = false; });

    } catch (error)
    {
      this.alertService.error(error);
    }
  }

  formBuild()
  {
		/**
				   *
				   *
				   *
				   * FORM
				   *
				   */

    this.form1 = this.formBuilder.group({
      rateBucketId: [],
      createDate: [],
      lastUpdate: [],
      name: [],
      rateBucketName: [],
      description: [],
      publicRateNote: [],
      rateBucketType: [],
      startDate: [],
      endDate: [],
      listPrice: [],
      listPriceAdjustmentPercent: [],
      listPriceAdjustmentAmount: [],
      minimumPriceSetByManager: [],
      minimumPriceSetByOwner: [],
      seasonCategory: [],
      seasonOccupancy: [],
      discountMaxPercent: [],
      discountLookForwardDays: [],
      discountHeadlineSpecialsLookForwardDays: [],
      discountHeadlineSpecialsMinNightsToAnalyze: [],
      discountIntervalDays: [],
      discountCombinationDays: [],
      discountAlorithm: [],
      minStayExpected: [],
      maxStayExpected: [],
      avgStayBySeason: [],
      shortTermGapMultiplier: [],
      shortTermGapPenaltyPercent: [],
      shortTermGapMinNightsReqRev: [],
      longTermGapMultiplier: [],
      longTermGapPenaltyPercent: [],
      longTermGapEmptyMultiplier: [],
      longTermGapEmptyPenaltyPercent: [],
      connectingFrontOrBackMultiplier: [],
      connectingFrontAndBackMultiplier: [],
      lengthOfStayDiscountFactorOffset: [],
      reportSearchApi: []
    });
  }

  // not used below but kept for reference.
  getUpdatedInputValues()
  {
    const updatedFormValues = {};
    this.form1['_forEachChild']((control, name) =>
    {

      if (control.dirty && !name.startsWith('where'))
      {
        updatedFormValues[name] = control.value;
      }
    });
    return (updatedFormValues);
  }

  getUpdatedConditionalValues()
  {
    const updatedFormValues = {};
    this.form1['_forEachChild']((control, name) =>
    {
      if (control.dirty && name.startsWith('where'))
      {
        console.log(name + ' ' + control.value);
        updatedFormValues[name] = control.value;
      }
    });
    return (updatedFormValues);
  }


}



